let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("eoyTp")).then(() => parcelRequire('iMa2r'));